import { noop as A, toValue as p, isObject as _, tryOnScopeDispose as L, isIOS as k, isClient as P, notNullish as C } from "./design-system.es150.js";
import { watch as b, ref as M, watchEffect as R, computed as O, getCurrentInstance as W, onMounted as I } from "vue";
const w = P ? window : void 0;
function h(r) {
  var s;
  const i = p(r);
  return (s = i == null ? void 0 : i.$el) != null ? s : i;
}
function E(...r) {
  let s, i, e, u;
  if (typeof r[0] == "string" || Array.isArray(r[0]) ? ([i, e, u] = r, s = w) : [s, i, e, u] = r, !s)
    return A;
  Array.isArray(i) || (i = [i]), Array.isArray(e) || (e = [e]);
  const t = [], c = () => {
    t.forEach((o) => o()), t.length = 0;
  }, a = (o, l, f, n) => (o.addEventListener(l, f, n), () => o.removeEventListener(l, f, n)), m = b(
    () => [h(s), p(u)],
    ([o, l]) => {
      if (c(), !o)
        return;
      const f = _(l) ? { ...l } : l;
      t.push(
        ...i.flatMap((n) => e.map((v) => a(o, n, v, f)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    m(), c();
  };
  return L(d), d;
}
let S = !1;
function F(r, s, i = {}) {
  const { window: e = w, ignore: u = [], capture: t = !0, detectIframe: c = !1 } = i;
  if (!e)
    return A;
  k && !S && (S = !0, Array.from(e.document.body.children).forEach((n) => n.addEventListener("click", A)), e.document.documentElement.addEventListener("click", A));
  let a = !0;
  const m = (n) => p(u).some((v) => {
    if (typeof v == "string")
      return Array.from(e.document.querySelectorAll(v)).some((y) => y === n.target || n.composedPath().includes(y));
    {
      const y = h(v);
      return y && (n.target === y || n.composedPath().includes(y));
    }
  }), d = (n) => {
    const v = h(r);
    if (!(!v || v === n.target || n.composedPath().includes(v))) {
      if (n.detail === 0 && (a = !m(n)), !a) {
        a = !0;
        return;
      }
      s(n);
    }
  };
  let o = !1;
  const l = [
    E(e, "click", (n) => {
      o || (o = !0, setTimeout(() => {
        o = !1;
      }, 0), d(n));
    }, { passive: !0, capture: t }),
    E(e, "pointerdown", (n) => {
      const v = h(r);
      a = !m(n) && !!(v && !n.composedPath().includes(v));
    }, { passive: !0 }),
    c && E(e, "blur", (n) => {
      setTimeout(() => {
        var v;
        const y = h(r);
        ((v = e.document.activeElement) == null ? void 0 : v.tagName) === "IFRAME" && !(y != null && y.contains(e.document.activeElement)) && s(n);
      }, 0);
    })
  ].filter(Boolean);
  return () => l.forEach((n) => n());
}
function V() {
  const r = M(!1), s = W();
  return s && I(() => {
    r.value = !0;
  }, s), r;
}
function g(r) {
  const s = V();
  return O(() => (s.value, !!r()));
}
function z(r, s, i = {}) {
  const { window: e = w, ...u } = i;
  let t;
  const c = g(() => e && "MutationObserver" in e), a = () => {
    t && (t.disconnect(), t = void 0);
  }, m = O(() => {
    const f = p(r), n = (Array.isArray(f) ? f : [f]).map(h).filter(C);
    return new Set(n);
  }), d = b(
    () => m.value,
    (f) => {
      a(), c.value && f.size && (t = new MutationObserver(s), f.forEach((n) => t.observe(n, u)));
    },
    { immediate: !0, flush: "post" }
  ), o = () => t == null ? void 0 : t.takeRecords(), l = () => {
    d(), a();
  };
  return L(l), {
    isSupported: c,
    stop: l,
    takeRecords: o
  };
}
function H(r, s = {}) {
  const { window: i = w } = s, e = g(() => i && "matchMedia" in i && typeof i.matchMedia == "function");
  let u;
  const t = M(!1), c = (d) => {
    t.value = d.matches;
  }, a = () => {
    u && ("removeEventListener" in u ? u.removeEventListener("change", c) : u.removeListener(c));
  }, m = R(() => {
    e.value && (a(), u = i.matchMedia(p(r)), "addEventListener" in u ? u.addEventListener("change", c) : u.addListener(c), t.value = u.matches);
  });
  return L(() => {
    m(), a(), u = void 0;
  }), t;
}
function N(r, s, i = {}) {
  const { window: e = w, initialValue: u, observe: t = !1 } = i, c = M(u), a = O(() => {
    var d;
    return h(s) || ((d = e == null ? void 0 : e.document) == null ? void 0 : d.documentElement);
  });
  function m() {
    var d;
    const o = p(r), l = p(a);
    if (l && e && o) {
      const f = (d = e.getComputedStyle(l).getPropertyValue(o)) == null ? void 0 : d.trim();
      c.value = f || u;
    }
  }
  return t && z(a, m, {
    attributeFilter: ["style", "class"],
    window: e
  }), b(
    [a, () => p(r)],
    (d, o) => {
      o[0] && o[1] && o[0].style.removeProperty(o[1]), m();
    },
    { immediate: !0 }
  ), b(
    c,
    (d) => {
      var o;
      const l = p(r);
      (o = a.value) != null && o.style && l && (d == null ? a.value.style.removeProperty(l) : a.value.style.setProperty(l, d));
    }
  ), c;
}
function Q(r, s, i = {}) {
  const { window: e = w, ...u } = i;
  let t;
  const c = g(() => e && "ResizeObserver" in e), a = () => {
    t && (t.disconnect(), t = void 0);
  }, m = O(() => {
    const l = p(r);
    return Array.isArray(l) ? l.map((f) => h(f)) : [h(l)];
  }), d = b(
    m,
    (l) => {
      if (a(), c.value && e) {
        t = new ResizeObserver(s);
        for (const f of l)
          f && t.observe(f, u);
      }
    },
    { immediate: !0, flush: "post" }
  ), o = () => {
    a(), d();
  };
  return L(o), {
    isSupported: c,
    stop: o
  };
}
function j(r, s = {}) {
  const {
    delayEnter: i = 0,
    delayLeave: e = 0,
    window: u = w
  } = s, t = M(!1);
  let c;
  const a = (m) => {
    const d = m ? i : e;
    c && (clearTimeout(c), c = void 0), d ? c = setTimeout(() => t.value = m, d) : t.value = m;
  };
  return u && (E(r, "mouseenter", () => a(!0), { passive: !0 }), E(r, "mouseleave", () => a(!1), { passive: !0 })), t;
}
export {
  w as defaultWindow,
  P as isClient,
  k as isIOS,
  _ as isObject,
  A as noop,
  C as notNullish,
  F as onClickOutside,
  p as toValue,
  L as tryOnScopeDispose,
  h as unrefElement,
  N as useCssVar,
  j as useElementHover,
  E as useEventListener,
  H as useMediaQuery,
  V as useMounted,
  z as useMutationObserver,
  Q as useResizeObserver,
  g as useSupported
};
//# sourceMappingURL=design-system.es125.js.map
